import { FavoriteCustomEvent } from './../../../../models/favorite.custom.event';
import { switchMap } from 'rxjs/operators';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ModalService } from 'src/app/common/services/modal/modal.service';
import { EditorChoice } from '../../../../models/editor.choice';
import { VisitorEvent } from '../../../../models/visitor.event';
import { EventDetailsStyle } from 'src/app/modules/shared/models/visitor.custom.settings';
import { VisitorCardBaseComponent } from '../visitor.card.base.component';
import { ActivatedRoute } from '@angular/router';
import { takeUntil, fromEvent, BehaviorSubject, timer } from 'rxjs';
import { VisitorPlace } from 'src/app/modules/shared/models/visitor.place';

@Component({
  selector: 'ig-visitor-fancy-card',
  templateUrl: './visitor.fancy.card.component.html',
  styleUrls: ['./visitor.fancy.card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VisitorFancyCardComponent
  extends VisitorCardBaseComponent
  implements AfterViewInit
{
  @HostBinding('class') hostClass = '';
  @Input() override item: VisitorEvent | VisitorPlace;
  @Input() editorChoiceText: EditorChoice;
  @Input() override detailsPageStyle: EventDetailsStyle = 'fancy';
  @Input() override favCustomEvents: FavoriteCustomEvent[] = [];

  // for other upcoming events
  @Input() override allItems: VisitorEvent[] = [];
  @Output() public onClick = new EventEmitter<any>();

  @ViewChild('card', { static: false }) card: ElementRef;
  isShowMoreInfo = false;

  constructor(
    public override activatedRoute: ActivatedRoute,
    public override modalService: ModalService
  ) {
    super(activatedRoute, modalService);
  }
  ngAfterViewInit(): void {
    if (this.item.socialName !== 'promotion') {
      this.addHoverLargerEffect();
    }
  }

  showPromotion() {
    if (this.item.hostLink) {
      window.open(this.item.hostLink, '_blank');
    }
  }

  addHoverLargerEffect() {
    const enter = fromEvent(this.card.nativeElement, 'mouseenter');
    const leave = fromEvent(this.card.nativeElement, 'mouseleave');

    enter
      .pipe(switchMap((e) => timer(1000).pipe(takeUntil(leave))))
      .subscribe((e) => {
        const box = this.card.nativeElement.getBoundingClientRect();
        const container = this.shadowRoot?.querySelector('.ig-infinite-scroll');
        if (!container) return;
        const containerBox = container.getBoundingClientRect();

        const scale =
          containerBox.width >= 1800 ? 'scale-[1.4]' : 'scale-[1.25]';

        const isSpan2 = box.width > 500;
        const isAtTop = box.top - containerBox.top < 50;
        const isAtRight = containerBox.right - box.right < 50;
        const isAtBttom = containerBox.bottom - box.bottom < 50;
        const isAtLeft = box.left - containerBox.left < 50;

        const offsetForSpan1 = scale === 'scale-[1.4]' ? 14 : 10;
        const offsetForSpan2 = scale === 'scale-[1.4]' ? 32 : 20;

        // need to specify these Tailwind classes to make sure they are bundled in the final CSS
        const translate = `translate-y-10 translate-x-10 translate-y-14 translate-x-14 translate-y-20 translate-x-20 translate-x-28 translate-x-32`;
        const translateMinus = `-translate-y-10 -translate-x-10 -translate-y-14 -translate-x-14 -translate-y-20 -translate-x-20 -translate-x-28 -translate-x-32`;

        const top = isAtTop ? `translate-y-${offsetForSpan1}` : '';
        const bottom = isAtBttom ? `-translate-y-${offsetForSpan1}` : '';
        const right = isAtRight
          ? isSpan2
            ? `-translate-x-${offsetForSpan2}`
            : `-translate-x-${offsetForSpan1}`
          : '';
        const left = isAtLeft
          ? isSpan2
            ? `translate-x-${offsetForSpan2}`
            : `translate-x-${offsetForSpan1}`
          : '';

        this.hostClass = `transition-all ${scale} z-10 relative card-more-info ${top} ${bottom} ${left} ${right}`;
        this.isShowMoreInfo = true;
      });

    leave.pipe(takeUntil(this.isDestroyed)).subscribe((e) => {
      this.hostClass = '';
      this.isShowMoreInfo = false;
    });
  }

  getCategories(): string {
    return (this.item as VisitorEvent).categories
      ?.map((c) => c.name)
      .join(', ');
  }
}
